import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { Input, Table, Button, Modal, Badge, Image } from "antd";
import FilePresentIcon from '@mui/icons-material/FilePresent';
import DataProcurationClient from "../../../Types/DataProcurationClient";
import DataRelationClient from "../../../Types/DataRelationClient";
import TypSignature from "../../Tsignature";

const Tab3 = (props: { form: any, DataSingCpt: DataRelationClient[], DataProCpt: DataProcurationClient[] }) => {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewOpenM1, setPreviewOpenM1] = useState(false);
    const [previewTitle, setPreviewTitle] = useState('');
    const [SearchR, SetSearchR] = useState<string>("");
    const [SearchP, SetSearchP] = useState<string>("");

    const columns: ColumnsType<DataProcurationClient> = [
        {
            title: 'Reférence',
            dataIndex: 'CODEREL',
            align: 'center',
            ellipsis: true,
            width: 100,
            filteredValue: [SearchP],
            onFilter: (value: any, record: any) => {
                return String(record.CODEREL)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.idclient)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Nom)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Prenom)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Tel)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.ville)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.DateDebut)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.DateFin)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.filiation)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.plafond)
                        .toLowerCase()
                        .includes(value.toLowerCase());
            },
        },
        {
            title: 'Id Client',
            dataIndex: 'idclient',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Nom',
            dataIndex: 'Nom',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Prenom',
            dataIndex: 'Prenom',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Téléphone',
            dataIndex: 'Tel',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Ville',
            dataIndex: 'ville',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Date Début',
            dataIndex: 'DateDebut',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Date Fin',
            dataIndex: 'DateFin',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Filiation',
            dataIndex: 'filiation',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Date Création',
            dataIndex: 'Datecre',
            align: 'center',
            ellipsis: true,
            width: 100,
        }
        ,
        {
            title: 'Photo ',
            dataIndex: 'photo',
            align: 'center',
            ellipsis: true,
            width: 100,
            render: (text: any, record: any) => (
                record.RelObject.photo ?
                    <span>
                        <Image
                            style={{ height: 30, width: 30 }}
                            src={record.RelObject.photo}
                            preview={{
                                src: record.RelObject.photo,
                            }}
                        />
                    </span>
                    : <Badge status='error' count='No Picture'></Badge>)
        },
        {
            title: 'Signature',
            align: 'left',
            ellipsis: true,
            width: 100,
            render: (text: any, record: any) => (
                record.RelObject.signature ?
                    <span>
                        <Image.PreviewGroup>
                            <Image
                                style={{ height: 30, width: 30 }}
                                src={record.RelObject.photo}
                                preview={{
                                    src: record.RelObject.signature,
                                }}
                            />
                        </Image.PreviewGroup>
                    </span>

                    : <Badge status='error' count='No Picture'></Badge>)
        },
        {
            title: 'Piece Jointe 1 ',
            align: 'center',
            ellipsis: true,
            width: 100,
            render: (text: any, record: any) => (
                record.RelObject.Piecej1 ?
                    <Button disabled={false} onClick={e => { setPreviewImage(record.RelObject.Piecej1); setPreviewTitle("View Document"); setPreviewOpen(true); }}>
                        <><FilePresentIcon /></>
                    </Button>
                    : <Badge status='error' count='no file'></Badge>
            )
        },
        {
            title: 'Piece Jointe 2 ',
            align: 'center',
            ellipsis: true,
            width: 100,
            render: (text: any, record: any) => (record.RelObject.Piecej2 ?
                <Button disabled={false} onClick={e => { setPreviewImage(record.RelObject.Piecej2); setPreviewTitle("View Document"); setPreviewOpen(true); }}>
                    <><FilePresentIcon /></>
                </Button>
                : <Badge status='error' count='no file'></Badge>
            )
        },
        {
            title: 'Plafond ',
            dataIndex: 'plafond',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: "",
            dataIndex: 'RelObject',
            align: 'center',
            width: 1,
            ellipsis: true
        }
    ]


    //INSTITULER
    const columns2: ColumnsType<DataRelationClient> = [
        {
            title: 'Reférence ',
            dataIndex: 'CODEREL',
            align: 'center',
            ellipsis: true,
            width: 100,
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.idclient)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.idclient)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Nom)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Prenom)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.Tel)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.ville)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.DateDebut)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.DateFin)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'Id Client',
            dataIndex: 'idclient',
            align: 'center',
            ellipsis: true,
            width: 100,

        },
        {
            title: 'Nom',
            dataIndex: 'Nom',
            align: 'center',
            ellipsis: true,
            width: 100,

        },
        {
            title: 'Prenom',
            dataIndex: 'Prenom',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Téléphone',
            dataIndex: 'Tel',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Filiation',
            dataIndex: 'filiation',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Date Création',
            dataIndex: 'Datecre',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Photo ',
            dataIndex: 'photo',
            align: 'center',
            ellipsis: true,
            width: 100,
            render: (text: any, record: any) => (
                <span>
                    <img
                        onClick={e => { setPreviewImage(record.RelObject.photo); setPreviewTitle("Preview Image"); setPreviewOpenM1(true); }}
                        style={{ height: 30, width: 30 }}
                        src={record.RelObject.photo}
                    ></img>
                </span>)
        },
        {
            title: 'Signature',
            dataIndex: 'Signature',
            ellipsis: true,
            width: 100,
            align: 'center',
            render: (text: any, record: any) => (
                <span>
                    <img
                        onClick={e => { setPreviewImage(record.RelObject.signature); setPreviewTitle("Preview Image"); setPreviewOpenM1(true); }}
                        style={{ height: 30, width: 30 }}
                        src={record.RelObject.signature}
                    ></img>
                </span>
            )
        },
        {
            title: 'Type',
            dataIndex: 'INSTITULER',
            align: 'center',
            ellipsis: true,
            width: 100,
        },
        {
            title: "",
            dataIndex: 'RelObject',
            width: 1,
            ellipsis: true,

        }
        ,
        {
            title: 'Plafond',
            dataIndex: 'Plafond',
            align: 'center',
            ellipsis: true,
            width: 100,
            render: (text: any, record: any) => (
                record.Plafond ? <span>
                    {record.Plafond} FCFA
                </span> : ''
            )
        },
    ]

    return (
        <>
            <div className='tabItem'>
                <div >
                    <Box className='border' fontStyle="inherit" width={"85%"} position={"absolute"} >
                      
                        <Box className='bordure1' fontStyle="inherit" >
                            <TypSignature width={3} widthCode={'15%'} Dissebled={true} />
                        </Box>

                         <Box className='bordure1' fontStyle="inherit" >
                            <legend >Signataires du compte</legend>
                            <Input.Search  onChange={(e) => { SetSearchR(e.target.value); }} placeholder=" Search here..." size="middle" loading={false} />
                           <Table sticky={true} pagination={false} bordered={true} size='small' style={{ width: 'auto' }} columns={columns2} dataSource={props.DataSingCpt} scroll={{ y: 150, x: 1300 }} />
 
                         </Box>

                          <Box className='bordure1' fontStyle="inherit">
                              <legend>Procurations du compte</legend>
                             <Input.Search disabled={false} onChange={(e) => { SetSearchP(e.target.value); }} placeholder=" Search here..." size="middle" loading={false} />
                             <Table sticky={true} bordered={true} pagination={false} dataSource={props.DataProCpt} size='small' style={{ width: 'auto' }} columns={columns} scroll={{ y: 150, x: 1300 }} />

                            </Box>
                          

                      

                        <Modal footer={false} style={{ maxWidth: '800' }} open={previewOpenM1} title={previewTitle} onOk={e => { setPreviewOpenM1(false) }} onCancel={e => { setPreviewOpenM1(false) }}>
                            <img alt="example" style={{ width: '100%', maxHeight: 500 }} src={previewImage} />
                        </Modal>
                        <Dialog open={previewOpen} title={previewTitle} >
                            <DialogTitle>Preview File</DialogTitle>
                            <DialogContent>
                                <embed width="900" height="500" type="application/pdf" src={previewImage} />
                            </DialogContent>
                            < DialogActions>
                                <Button type='default' color='red' onClick={() => { setPreviewOpen(false) }}>Fermer</Button>
                            </DialogActions>
                        </Dialog>
                    </Box>
                </div>
            </div>
        </>
    );

}

export default Tab3;